import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themtrungtamdangkiem() {
  const [xa, setXa] = React.useState([]);
  const [xaid, setXaid] = React.useState(0);
  const [ten, setTen] = React.useState("");
  const [ma, setMa] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [dkvbaccao, setDkvbaccao] = React.useState(0);
  const [tongsodkv, setTongsodkv] = React.useState(0);
  const [sodaychuyenhoatdong, setSodaychuyenhoatdong] = React.useState(0);
  const [tongsodaychuyen, setTongsodaychuyen] = React.useState(0);
  const [sldaychuyenkiemdinh, setSldaychuyenkiemdinh] = React.useState(0);
  const [loaidaychuyenkiemdinh, setLoaidaychuyenkiemdinh] = React.useState("");
  const [sonhanviennghiepvu, setSonhanviennghiepvu] = React.useState(0);
  const [coquanquanly, setCoquanquanly] = React.useState("");
  const [thutruongdonvi, setThutruongdonvi] = React.useState("");
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getxaphuong = () => {
    var url = Config.backend + "/api/Donvi/getpxgialai?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXa(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const inserttrungtam = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/CoSoGTVT/themtrungtamdangkiem";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          ten: ten,
          ma: ma,
          diachi: diachi,
          sodienthoai: sodienthoai,
          thon_id: null,
          phuongxa_id: xaid,
          huyentp_id: null,
          dkvbaccao: dkvbaccao,
          tongsodkv: tongsodkv,
          sodaychuyenhoatdong: sodaychuyenhoatdong,
          tongsodaychuyen: tongsodaychuyen,
          ghichu: ghichu,
          sldaychuyenkiemdinh: sldaychuyenkiemdinh,
          loaidaychuyenkiemdinh: loaidaychuyenkiemdinh,
          sonhanviennghiepvu: sonhanviennghiepvu,
          coquanquanly: coquanquanly,
          thutruongdonvi: thutruongdonvi,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!xaid || xaid === 0) {
      return Error.ER0012;
    }
    if (ten.trim() === "") {
      return Error.ER0013;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getxaphuong();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={xa}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setXaid(value.id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn Xã/phường"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "32px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên"
                variant="outlined"
                size="small"
                value={ten}
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Mã trung tâm"
                variant="outlined"
                size="small"
                value={ma}
                onChange={(event) => {
                  setMa(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Tổng số đăng kiểm viên"
                variant="outlined"
                size="small"
                value={tongsodkv}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setTongsodkv(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Số đăng kiểm viên bậc cao"
                variant="outlined"
                size="small"
                value={dkvbaccao}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setDkvbaccao(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Tổng số dây chuyền"
                variant="outlined"
                size="small"
                value={tongsodaychuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setTongsodaychuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Số dây chuyền kiểm định"
                variant="outlined"
                size="small"
                value={sldaychuyenkiemdinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSldaychuyenkiemdinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Loại dây chuyền kiểm định"
                variant="outlined"
                size="small"
                value={loaidaychuyenkiemdinh}
                onChange={(event) => {
                  setLoaidaychuyenkiemdinh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Số dây chuyền hoạt động"
                variant="outlined"
                size="small"
                value={sodaychuyenhoatdong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSodaychuyenhoatdong(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Số nhân viên nghiệp vụ"
                variant="outlined"
                size="small"
                value={sonhanviennghiepvu}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSonhanviennghiepvu(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Thủ trưởng"
                variant="outlined"
                size="small"
                value={thutruongdonvi}
                onChange={(event) => {
                  setThutruongdonvi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Đơn vị quản lý"
                variant="outlined"
                size="small"
                value={coquanquanly}
                onChange={(event) => {
                  setCoquanquanly(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Ghi chú"
                variant="outlined"
                size="small"
                value={ghichu}
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={inserttrungtam}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
